// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"83ba2db5","703":"a95613f5","787":"db613c88"}[chunkId] + ".chunk.js";
};